import React, { Component } from 'react';
import { Modal, Header, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { submit, isValid } from 'redux-form';
import PropTypes from 'prop-types';

import { VendingMachineFieldEnum } from 'Common/FieldEnum';
import { VENDING_MACHINE_ENTRY_FORM_NAME } from 'Common/FormEnum';
import { VendingMachineEntryForm } from './VendingMachineEntryForm';

class VendingMachineEntryModalContainer extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    rowData: PropTypes.object,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
  };

  static defaultProps = {
    isOpen: false,
  };

  state = {};

  render() {
    const {
      isOpen,
      onClose,
      rowData,
      isReadOnly,
      onSubmit,
      submit,
      isValid,
    } = this.props;

    const isNew = !rowData || !rowData[VendingMachineFieldEnum.MachineId];

    return (
      <Modal open={isOpen} onClose={onClose} size="large" closeIcon>
        <Header
          content={`${isNew ? 'Add' : 'Edit'} Vending Machine`}
          icon="signup"
        />

        <Modal.Content className="p-t-0">
          <Modal.Description>
            <VendingMachineEntryForm
              onSubmit={onSubmit}
              initialValues={rowData}
            />
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button
            inverted
            color="orange"
            size="big"
            content="Save"
            onClick={() => submit(VENDING_MACHINE_ENTRY_FORM_NAME)}
            disabled={isReadOnly || !isValid}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    isValid: isValid(VENDING_MACHINE_ENTRY_FORM_NAME)(state),
  };
};

const mapDispatchToProps = { submit };

export const VendingMachineEntryModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(VendingMachineEntryModalContainer);



// WEBPACK FOOTER //
// ./src/pages/vendingsetup/components/VendingMachineEntryModal.js